import React from "react";
import './ReportsView.scss'

import {
  Form, Radio, Button, Table, Header, Pagination, Label,
  Input, Tab, Checkbox, Dimmer, Dropdown, Icon
} from 'semantic-ui-react'

import {getLanguageScope} from "../../../helpers";
import moment from "moment/moment";
const _i18n = getLanguageScope('reports_settings');

export default class ReportsSettings extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    const {loadDevices} = this.props;

    loadDevices && loadDevices()
  }

  renderDevices(){
    const {devices, changeReportDevicesManual, changeReportDevicesAutomatic} = this.props;

    const deviceItems = _.map(devices || [], (device, key) => {
      return (
        <Table.Row key={key}>
          <Table.Cell>
            {device.device_name}
          </Table.Cell>
          <Table.Cell>
            {device.employee_name}
          </Table.Cell>
          <Table.Cell textAlign={'center'}>
            <Checkbox onChange={() => changeReportDevicesManual(device.device_id)} checked={device.manual_enabled}/>
          </Table.Cell>
          <Table.Cell textAlign={'center'}>
            <Checkbox onChange={() => changeReportDevicesAutomatic(device.device_id)} checked={device.automatic_enabled}/>
          </Table.Cell>
        </Table.Row>
      )
    });

    if (!(deviceItems && deviceItems.length)) {
      deviceItems.push(
        <Table.Row key={-1}>
          <Table.Cell colSpan={4}>
            <Header as={'h4'} content={_i18n('no_devices')}/>
          </Table.Cell>
        </Table.Row>
      )
    }

    return deviceItems;
  }

  render(){
    const { selected_all_manual, selected_all_automatic, selectAllManualDevices, selectAllAutomaticDevices } = this.props;

    return (
      <div>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                {_i18n('device')}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {_i18n('assigned_employee')}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign={'center'}>
                {_i18n('manual_enabled')}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign={'center'}>
                {_i18n('automatic_enabled')}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderDevices()}
          </Table.Body>

          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell/>
              <Table.HeaderCell/>
              <Table.HeaderCell textAlign={'center'}>
                <Checkbox label={_i18n('select_all')} onChange={() => selectAllManualDevices()} checked={selected_all_manual}/>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign={'center'}>
                <Checkbox label={_i18n('select_all')} onChange={() => selectAllAutomaticDevices()} checked={selected_all_automatic}/>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>

        {/*<Pagination*/}
          {/*activePage={history_active_page}*/}
          {/*onPageChange={this.handlePaginationChange}*/}
          {/*firstItem={null}*/}
          {/*lastItem={null}*/}
          {/*pointing*/}
          {/*secondary*/}
          {/*className='center-pagination'*/}
          {/*totalPages={total_pages}*/}
        {/*/>*/}

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Reports/components/ReportsSettingsView.js